<template>
    <div class="time-picker tw-w-full tw-flex tw-flex-col">
        <label v-text="label" class="form-label"></label>
        <div class="tw-flex tw-flex-col tw-relative">
            <div class="tw-flex-1 input-time tw-flex tw-justify-center tw-items-center tw-relative" :class="disabled ? 'tw-opacity-50 tw-cursor-not-allowed': 'tw-cursor-pointer'" @click="openTimePicker">
                <i class="far fa-clock tw-absolute tw-left-5"></i>
                <p class="tw-text-sm" v-text="showTime" ></p>
            </div>
            <div class="card-time-picker card-shadow tw-bg-white tw-rounded tw-grid tw-w-full tw-right-0 tw-grid-cols-2 tw-absolute tw-z-50 tw-overflow-hidden" :class="position === 'bottom' ? 'top' :'bottom' " v-if="openPicker" v-click-outside="closeTimePicker">
                <div class="tw-pt-4">
                    <h4 class="tw-text-center tw-mb-3 tw-text-sm tw-font-bold">{{ translations['events.hour'] }}</h4>
                    <div v-bar class="time-scrollbar tw-relative">
                        <div class="tw-flex-1">
                            <ul class="tw-px-4 tw-pt-2 tw-flex tw-flex-col tw-items-center">
                                <li :ref="'hour-' + hour" class="time-picker-items tw-cursor-pointer tw-w-auto tw-p-1 tw-text-gray-500 tw-text-center tw-rounded-full tw-flex tw-justify-center tw-items-center tw-mb-1 hover:tw-bg-gray-0" v-for="(hour, index) in hours" :key="index" v-text="hour" @click="setHour(hour)" :class="{'selected' : selectedHour === hour}"></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="tw-pt-4">
                    <h4 class="tw-text-center tw-mb-3 tw-text-sm tw-font-bold">{{ translations['events.minute'] }}</h4>
                    <div v-bar class="time-scrollbar tw-relative">
                        <div class="tw-flex-1">
                            <ul class="tw-px-4 tw-pt-2 tw-flex tw-flex-col tw-items-center">
                                <li :ref="'minute-' + minute" class="time-picker-items tw-cursor-pointer tw-w-auto tw-p-1 tw-text-gray-500 tw-text-center tw-rounded-full tw-flex tw-justify-center tw-items-center tw-mb-1 hover:tw-bg-gray-0" v-for="(minute, index) in minutes" :key="index" v-text="minute" @click="setMinute(minute)" :class="{'selected' : selectedMinute === minute}"></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import vClickOutside from 'v-click-outside';
import Global from '../mixins/Global';

export default {
    name: 'TimePicker',

    mixins: [Global],

    directives: {
        clickOutside: vClickOutside.directive
    },

    props: {
        value: {
            default: '',
        },
        format: {
            default: 'YYYY-MM-DD HH:mm:ss',
        },
        position: {
            type: String,
            default: 'bottom'
        },
        label: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
        
    data() {
        return {
            openPicker: false,
            selectedHour: '00',
            selectedMinute: '00',
            initial_time_set: true,
        }
    },

    watch: {
        selectedHourAndMinute([newHour, newMin], [oldHour, oldMin]) {
            if (((newHour !== oldHour && newMin !== '00') || (newMin !== oldMin && newHour !== '00'))  && this.initial_time_set && this.openPicker) {
                this.closeTimePicker();
                this.initial_time_set = false
            } else if ((newHour !== oldHour || newMin !== oldMin) && !this.initial_time_set && this.openPicker) {
                this.closeTimePicker();
            }
        }
    },

    computed: {
        showTime() {
            return `${this.selectedHour}:${this.selectedMinute}`;
        },

        minutes() {
           return this.calculateAmountOfNumbers(60, 5);
        },

        hours() {
           return this.calculateAmountOfNumbers(24,1);
        },

        selectedHourAndMinute() {
            return [this.selectedHour, this.selectedMinute];
        }
    },

    methods: {
        setHour(hour) {
            this.selectedHour = hour;
        },
        setMinute(minute) {
            this.selectedMinute = minute;
        },
        closeTimePicker() {
            const selectedTime = `${this.selectedHour}:${this.selectedMinute}`;
            
            this.$emit('setTime', selectedTime);
            this.openPicker = false;
        },
        openTimePicker() {
            if (!this.disabled) {
                this.openPicker = true;

                if (this.selectedHour !== '--' && this.selectedMinute !== '--') {
                    this.$nextTick(() => {
                        const goToRef = (ref) => {
                            this.$refs[ref][0].scrollIntoView({block: "center", inline: "nearest"});
                        };

                        goToRef(`hour-${this.selectedHour}`);
                        goToRef(`minute-${this.selectedMinute}`);
                    });
                }
            }
        },
        calculateAmountOfNumbers(length,steps) {
            let numbers = [];
            for (let i = 0; i < length; i+=steps) {
                const iString = i.toString();
                if (iString.length < 2) {
                    numbers.push(`0${iString}`)
                } else {
                   numbers.push(iString)
                }
            }

            return numbers;
        },

        setHoursAndMinutes(){
            if (this.value !== '') {
                let hours = moment(this.value, this.format).get('hours');
                let minutes = moment(this.value, this.format).get('minutes');

                if (hours < 10) {
                    hours = hours.toString();
                    hours = '0' + hours;
                } else {
                    hours = hours.toString();
                }

                if (minutes < 10) {
                    minutes = minutes.toString();
                    minutes = '0' + minutes;
                } else {
                    minutes = minutes.toString();
                }

                this.selectedHour = hours;
                this.selectedMinute = minutes;
            }
        },
    },

    mounted() {
        this.setHoursAndMinutes();
    },
}
</script>

<style lang="scss" scoped>
    .time-picker {
        .input-time {
            @apply tw-rounded tw-bg-input;
            border: 0;
            min-height: 48px;
            margin-bottom: 0 !important;
            color: #696969;
            font-size: 14px;

            &:hover {
                background: #eaecef;
            }

            .fa-clock {
                top: 50%;
                transform: translateY(-50%);
            }
        }


        .card-time-picker {
            height: 179px;
            width: 142px;

            &.bottom {
                bottom: 57px;
            }

            &.top {
                top: 57px;
            }

            &.card-shadow {
                box-shadow: 0 1px 3px #00000029;
            }

            &:after {
                @apply tw-absolute tw-z-10 tw-left-0 tw-w-full;
                content: "";
                height: 12px;
                bottom: -2px;
                background: -webkit-gradient(linear, left top, left bottom, from(transparent), to(#ffffff));
                background: linear-gradient(to bottom, transparent 0%, #ffffff 100%);
            }

            .time-scrollbar {
                height: 143px;

                .time-picker-items {
                    width: 30px;
                    height: 30px;
                }
            }

            .time-scrollbar:before {
                @apply tw-absolute tw-z-10 tw-top-0 tw-left-0 tw-w-full;
                content: "";
                height: 12px;
                background: -webkit-gradient(linear, left bottom, left top, from(transparent), to(#ffffff));
                background: linear-gradient(to top, transparent 0%, #ffffff 100%);
            }
        }
    }
</style>